export default  {
  data(){
    return {
      enumerate:{

      },
    }
  },
  computed:{
    quoteType(){
      const L = this.$store.state.L || {}
      return [
        {value:'PQ', label: L.projectQuote},
        {value:'OQ', label: L.oneTime}
      ]
    }
  },
  methods:{
    getQuoteType(val){
      if(val==='') return ''
      let text = ''
      this.quoteType.forEach((item)=>{
        if(item.value==val){
          text=item.label
        }
      })
      return text
    }
  }
}